"use client";

import React from "react";
import { Building2, Maximize2, House, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const extensions = [{
  title: "Double Storey",
  subtitle: "Extensions",
  description: "Elevate your property with our premium double storey house extensions. We ensure flawless structural integrity while maximizing your living space and property value.",
  icon: Building2,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586109/img/architectural_blueprint_ghost_1.png",
  link: "/OurCraftPage"
}, {
  title: "Side Return",
  subtitle: "Extensions",
  description: "Transform unused alleyways into expansive, light-filled living areas. A perfect architectural alternative or addition to a traditional single storey extension.",
  icon: Maximize2,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586109/img/architectural_blueprint_ghost_2.png",
  link: "/OurCraftPage"
}, {
  title: "Rear",
  subtitle: "Extensions",
  description: "Seamlessly blend your indoor and outdoor spaces. Our expert North West London team delivers unparalleled craftsmanship for every bespoke rear extension project.",
  icon: House,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586109/img/architectural_blueprint_ghost_3.png",
  link: "/OurCraftPage"
}];
export default function OurSignatureExtensions() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-signature-extensions" className="dark bg-background text-foreground py-24 md:py-32 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-10" style={{
      backgroundImage: 'linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)',
      backgroundSize: '4rem 4rem'
    }}>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div ref={headerRef} className={`mb-16 md:mb-24 max-w-3xl transition-all duration-1000 transform ${isHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-sm font-mono tracking-[0.2em] text-muted-foreground uppercase mb-4">
            SolidTrust Builders
          </h2>
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light tracking-tight mb-6">
            Our Signature <br className="hidden md:block" />
            <span className="font-semibold">Extensions</span>
          </h3>
          <div className="h-px w-24 bg-primary mb-6"></div>
          <p className="text-lg text-muted-foreground leading-relaxed">Expert builders in North West London, we specialize in <b data-ast-id="f:/src/pages/NorthWestLondonExpertBuilder/sections/OurSignatureExtensions.tsx|sig:q40rik" data-ast-start="3086" data-ast-end="3277">loft extensions and home renovations to</b> transform homes with uncompromising quality and structural excellence.</p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {extensions.map((ext, i) => <div key={i} data-index={i} className={`transition-all duration-1000 delay-${i * 200} transform ${isGridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-16'}`}>
              <Card className="group relative h-full overflow-hidden rounded-none border-none bg-white text-black dark:bg-white dark:text-black shadow-2xl transition-transform duration-500 hover:-translate-y-2 flex flex-col">
                
                {}
                <img src={ext.image} alt={`${ext.title} blueprint`} className="absolute inset-0 z-0 h-full w-full object-cover opacity-0 transition-opacity duration-700 group-hover:opacity-15 pointer-events-none grayscale mix-blend-multiply" />

                <CardHeader className="relative z-10 pt-12 pb-6">
                  <ext.icon size={56} strokeWidth={1} className="mb-8 text-black transition-transform duration-500 group-hover:scale-110" />
                  <CardTitle className="text-2xl font-serif font-light tracking-wide uppercase text-black flex flex-col gap-1">
                    <span>{ext.title}</span>
                    <span className="font-bold">{ext.subtitle}</span>
                  </CardTitle>
                </CardHeader>
                
                <CardContent className="relative z-10 flex-grow">
                  <p className="text-black/70 leading-relaxed font-sans">
                    {ext.description}
                  </p>
                </CardContent>

                <CardFooter className="relative z-10 pb-12 pt-6">
                  <Button asChild variant="link" className="p-0 h-auto text-black hover:text-black/70 font-mono tracking-widest uppercase text-xs group/btn">
                    <Link to={ext.link}>
                      Explore Project 
                      <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover/btn:translate-x-2" />
                    </Link>
                  </Button>
                </CardFooter>

                {}
                <div className="absolute bottom-0 left-0 h-1 w-0 bg-black transition-all duration-500 group-hover:w-full z-10"></div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}